import { useEffect } from "react";

/**
 * Ungespeicherte Eingaben im Creator-Portal (Befund 4): Seiten mit halb ausgefüllten Formularen melden sich hier an;
 * der Agenturwechsel fragt dann nach („Arbeitsbereich wechseln? Ungespeicherte Änderungen gehen verloren.“).
 */
const open = new Set<string>();

export function useUnsaved(key: string, dirty: boolean): void {
  useEffect(() => {
    if (dirty) open.add(key);
    else open.delete(key);
    return () => {
      open.delete(key);
    };
  }, [key, dirty]);
}

export function hasUnsaved(): boolean {
  return open.size > 0;
}
